import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminSupportChatApi as n } from "@maat/api-chat";
//#region src/hooks/useAdminSupportUnreadQuery.ts
var r = () => {
	let r = t({
		queryKey: e.adminSupportUnread(),
		queryFn: () => n.getUnreadCounts()
	}), i = /* @__PURE__ */ new Map();
	for (let e of r.data?.items ?? []) e.external_reference_id && i.set(e.external_reference_id, e);
	return {
		...r,
		byTicketId: i
	};
};
//#endregion
export { r as useAdminSupportUnreadQuery };
